function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var core = require('core/main');

//paymentMethodMutationObserver, onPaymentMethodObserverShow, and onPaymentMethodObserverIframePresent must be before all the integrations that rely on them below to prevent race conditions
core.baseFiles.paymentMethodMutationObserver = function paymentMethodMutationObserver() {
  var targets = $('.js-paymentmethod-mutationobserver');
  if (targets && targets.length) {
    var _iterator = _createForOfIteratorHelper(targets),
      _step;
    try {
      var _loop = function _loop() {
          var target = _step.value;
          config = {
            subtree: true,
            childList: true
          };
          mutationObserver = new MutationObserver(function (mutationList, observer) {
            var _iterator2 = _createForOfIteratorHelper(mutationList),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var mutationRecord = _step2.value;
                if (mutationRecord.addedNodes) {
                  var _iterator3 = _createForOfIteratorHelper(mutationRecord.addedNodes),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var addNode = _step3.value;
                      $('body').trigger('PaymentMethodObserver:AddNode', {
                        addNode: addNode,
                        target: target,
                        observer: observer
                      });
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          });
          mutationObserver.observe(target, config);
        },
        config,
        mutationObserver;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
core.baseFiles.onPaymentMethodObserverShow = function onPaymentMethodObserverShow() {
  $('body').on('PaymentMethodObserver:Show', function (e, data) {
    var targets = $('.js-paymentmethodwarning-msgcontainer');
    if (targets && targets.length) {
      var _iterator4 = _createForOfIteratorHelper(targets),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var target = _step4.value;
          target = $(target);
          if (data && data.name) {
            target.data(data.name + '_show', data.show);
            target.attr('data-' + data.name + '_show', data.show);
          }
          if (target.data('iframepresent') === true) {
            var dataNames = [];
            var attrs = target.data();
            for (var _i = 0, _Object$keys = Object.keys(attrs); _i < _Object$keys.length; _i++) {
              var attr = _Object$keys[_i];
              var splits = attr.split('_');
              if (splits.length === 2) {
                if (attrs[attr] === true && splits[1] === 'show') {
                  dataNames.push(splits[0]);
                }
              }
            }
            var newMsg = '';
            var disable = false;
            for (var _i2 = 0, _dataNames = dataNames; _i2 < _dataNames.length; _i2++) {
              var dataName = _dataNames[_i2];
              if (target.data(dataName + '_disable') === true) {
                disable = true;
                newMsg = '<p>' + target.data(dataName + '_msg') + '</p>';
                break;
              }
              if (target.data(dataName + '_msg')) {
                newMsg += '<p>' + target.data(dataName + '_msg') + '</p>';
              }
            }
            if (newMsg.length) {
              target.removeClass('d-none');
            } else {
              target.addClass('d-none');
            }
            if (disable) {
              target.siblings('.js-paymentmethodwarning-affectedcontainer').attr('disabled', true);
            } else {
              target.siblings('.js-paymentmethodwarning-affectedcontainer').removeAttr('disabled');
            }
            target.html(newMsg);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  });
};
core.baseFiles.onPaymentMethodObserverIframePresent = function onPaymentMethodObserverIframePresent() {
  $('body').on('PaymentMethodObserver:iframePresent', function () {
    $('body').trigger('PaymentMethodObserver:Show');
  });
};
core.baseFiles.base = require('./product/base');
core.baseFiles.cart = require('./cart');

// WORKWEAR MODIFICATION - Comment unused code
// var siteIntegrations = require('./integrations/siteIntegrationsUtils');
// var toggleObject = siteIntegrations.getIntegrationSettings();
// if (toggleObject.bopisCartridgeEnabled) {
//     // adding to main.js to make accessible for quickview
//     core.baseFiles.pdpInstoreInventory = require('./integrations/bopis/product/pdpInstoreInventory');
// }
// if (toggleObject.sfcommercepaymentsCartridgeEnabled) {
//     core.baseFiles.sfcppayment = require('./integrations/commercepayments/components/payment');
// }

module.exports = core;